import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.promise.finally";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import { localizeDate } from '../../../utils/vuex';
import ApiService from '../../../services/apiService';
import get from 'lodash/get';
var defaultItemsPerPage = 10;
var defaultTableOptions = {
  sortBy: ['createdAt'],
  sortDesc: [true],
  page: 1,
  itemsPerPage: defaultItemsPerPage
};
export default {
  name: 'CoreBackgroundJobsList',
  props: {},
  data: function data() {
    return {
      deletePrompt: false,
      // item for deletion
      selectedItem: {},
      list: [],
      isFetching: false,
      tableOptions: defaultTableOptions,
      serverItemsLength: -1
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions'])), {}, {
    isIotHubRead: function isIotHubRead() {
      return this.permissions['IotHub.read'];
    },
    tableLocalizations: function tableLocalizations() {
      return {
        headers: [{
          text: this.$i18n_t('BackgroundJobs.BackgroundJobs.table.id'),
          value: 'id',
          align: 'center'
        }, {
          text: this.$i18n_t('BackgroundJobs.BackgroundJobs.table.name'),
          value: 'name',
          align: 'start'
        }, {
          text: this.$i18n_t('BackgroundJobs.BackgroundJobs.table.state'),
          value: 'state',
          align: 'start'
        }, {
          text: this.$i18n_t('BackgroundJobs.BackgroundJobs.table.type'),
          value: 'type',
          align: 'start'
        }, {
          text: this.$i18n_t('BackgroundJobs.BackgroundJobs.table.format'),
          value: 'format',
          align: 'start'
        }, {
          text: this.$i18n_t('BackgroundJobs.BackgroundJobs.table.resource'),
          value: 'resource',
          align: 'start'
        }, {
          text: this.$i18n_t('BackgroundJobs.BackgroundJobs.table.createdAt'),
          value: 'createdAt'
        }].concat(_toConsumableArray(this.isIotHubRead ? [{
          align: 'end',
          sortable: false,
          value: 'actions'
        }] : [])),
        footerProps: {
          itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
          itemsPerPageOptions: [defaultItemsPerPage, 20, 50]
        }
      };
    }
  }),
  watch: {
    tableOptions: {
      handler: function handler() {
        this.fetchList();
      },
      deep: true
    }
  },
  created: function created() {
    this.fetchList();
  },
  methods: {
    fetchList: function fetchList() {
      var _this = this;

      if (this.isFetching) {
        return;
      }

      this.isFetching = true;
      var _this$tableOptions = this.tableOptions,
          sortBy = _this$tableOptions.sortBy,
          sortDesc = _this$tableOptions.sortDesc,
          page = _this$tableOptions.page,
          itemsPerPage = _this$tableOptions.itemsPerPage;
      var sortItem = sortBy && sortBy.length ? sortBy[0] : 'createdAt';
      var doSortDesc = sortDesc && sortDesc.length ? sortDesc[0] : true;
      var usedPage = Math.max(1, page || 1);
      var limit = itemsPerPage || defaultItemsPerPage;
      var offset = (usedPage - 1) * limit;
      ApiService.fetchBackgroundJobs(offset, limit, sortItem, doSortDesc).then(function (res) {
        _this.list = res.data;
        _this.serverItemsLength = res.pagination.itemCount;
      }).catch(function () {
        _this.$snack(_this.$i18n_t('BackgroundJobs.BackgroundJobs.snacks.fetchJobFailed'), 'error');
      }).finally(function () {
        _this.isFetching = false;
      });
    },
    deletePromise: function deletePromise() {
      return ApiService.deleteBackgroundJob(this.selectedItem.id);
    },
    localizeDate: localizeDate,
    showDeletePrompt: function showDeletePrompt(item) {
      this.selectedItem = item;
      this.deletePrompt = true;
    },
    deleteItem: function deleteItem() {
      var _this2 = this;

      this.deletePrompt = false;
      this.deletePromise().then(function () {
        _this2.$snack(_this2.$i18n_t('BackgroundJobs.BackgroundJobs.snacks.deleteSuccess'), 'success');

        _this2.fetchList();
      }).catch(function (error) {
        console.error(_this2.$i18n_t('BackgroundJobs.BackgroundJobs.snacks.deleteFailed'), error);

        if (error.response && _this2.$i18n_t("Error.".concat(error.response.data.message))) {
          _this2.$snack(_this2.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this2.$snack(_this2.$i18n_t('BackgroundJobs.BackgroundJobs.snacks.deleteFailed'), 'error');
        }
      });
    },
    downloadItem: function downloadItem(item) {
      var _this3 = this;

      ApiService.fetchBackgroundJob(item.id).then(function (res) {
        var fileId = get(res, 'result.fileId');
        var API_HOST = "".concat(process.env.VUE_APP_API_HOST).concat(process.env.VUE_APP_API_PATH);
        var TOKEN = localStorage.getItem('token');
        window.open("".concat(API_HOST, "/upload/v2/").concat(fileId, "?token=").concat(TOKEN));
      }).catch(function () {
        _this3.$snack(_this3.$i18n_t('BackgroundJobs.BackgroundJobs.snacks.fetchJobFailed'), 'error');
      });
    }
  }
};